module.exports = __webpack_public_path__ + "static/media/light-motion-deployment-scenario.ba1f8d9.mp4";